import { render } from "./WarehouseCategoryModal.vue?vue&type=template&id=e6177232"
import script from "./WarehouseCategoryModal.vue?vue&type=script&lang=js"
export * from "./WarehouseCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__